import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	popover: {
		maxWidth: "300px",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		padding: 16,
		border: "1px solid",
		boxShadow: "none",
		borderColor: colors.gray[200]
	},
	popoverTitle: {
		fontSize: "16px",
		fontWeight: 700
	}
}))

export default useStyles
